import React from "react";
import { Typography } from "@material-ui/core";
import { IFotoObraResponse } from "models/response/foto-obra-response";
import { GalleryCaption, GalleryGrid, GalleryItem } from "./photo-gallery.styles";

interface PhotoGalleryProps {
  photos?: IFotoObraResponse[];
}

export function PhotoGallery({ photos }: PhotoGalleryProps) {
  if (!photos || photos.length === 0) {
    return <Typography variant="body2" color="textSecondary">Nenhuma foto anexada.</Typography>;
  }

  return (
    <GalleryGrid>
      {photos.map((photo) => (
        <GalleryItem key={photo.id} onClick={() => window.open(photo.imageUrl, "_blank")}>
          <img src={photo.imageUrl} alt={photo.descricao} />
          <GalleryCaption>{photo.descricao}</GalleryCaption>
        </GalleryItem>
      ))}
    </GalleryGrid>
  );
}
